import { EXAMPLE_COLUMNS } from "./types";
import type { CardItem } from "./types";
import { ImageCard } from "./cards/ImageCard";
import { CircleImageCard } from "./cards/CircleImageCard";
import { QuoteCard } from "./cards/QuoteCard";
import { InsightCard } from "./cards/InsightCard";
import { ExtractionLink } from "./cards/ExtractionLink";

function renderCard(card: CardItem, index: number) {
	switch (card.type) {
		case "image":
			return <ImageCard key={index} data={card} />;
		case "circle-image":
			return <CircleImageCard key={index} data={card} />;
		case "quote":
			return <QuoteCard key={index} data={card} />;
		case "insight":
			return <InsightCard key={index} data={card} />;
		case "extraction-link":
			return <ExtractionLink key={index} />;
	}
}

const PARALLAX_SPEEDS = ["-50px", "-120px", "-80px"];

export function LandingExamples() {
	return (
		<section className="mx-auto max-w-[1400px] px-6 lg:px-12">
			<style>{`
				${PARALLAX_SPEEDS.map(
					(dist, i) => `
					@keyframes parallax-col-${i} {
						from { transform: translateY(0); }
						to { transform: translateY(${dist}); }
					}
					.parallax-col-${i} {
						animation: parallax-col-${i} linear both;
						animation-timeline: scroll(root);
						animation-range: 50px 600px;
					}
				`,
				).join("")}
			`}</style>
			<div
				className="grid gap-6"
				style={{ gridTemplateColumns: "repeat(12, 1fr)" }}
			>
				{EXAMPLE_COLUMNS.map((column, colIndex) => {
					const contentCards = column.cards.filter(
						(c) => c.type !== "extraction-link",
					);
					const hasExtraction = column.cards.some(
						(c) => c.type === "extraction-link",
					);

					return (
						<div
							key={colIndex}
							className={`parallax-col-${colIndex} relative flex flex-col gap-12 ${column.offsetTop ?? ""}`}
							style={{ gridColumn: `span ${column.span}` }}
						>
							{/* Vertical line spans full column height */}
							<div className="via-gold/20 pointer-events-none absolute top-0 bottom-0 left-1/2 z-0 w-px -translate-x-1/2 bg-gradient-to-b from-transparent to-transparent" />

							{contentCards.map((card, cardIndex) =>
								renderCard(card, cardIndex),
							)}

							{hasExtraction && <ExtractionLink />}
						</div>
					);
				})}
			</div>
		</section>
	);
}
